import { action } from 'satcheljs';
import { AnonymousCalendarEvent } from '../utils/calendarEventUtils';

/**
 * setCalendarEventDetails action
 */
export default action(
    'setCalendarEventDetails',
    (event: AnonymousCalendarEvent, eventDetailsFetched: boolean) => ({
        event,
        eventDetailsFetched,
    })
);
